// extracted by mini-css-extract-plugin
export default {"container":"EnjoyGames_container__LvmG+","row_1":"EnjoyGames_row_1__XzuuL","row_2":"EnjoyGames_row_2__GEm0i"};